// @ts-nocheck
import React, { useContext } from 'react';
import appConst from '../Utilities/appConst.json';
import '../styles/summary.css';
import Accordion from '../shared/Accordion';
import { LanguageContext } from '../context/language/LanguageContext';

type ShippingMethodExtraDataProps = {
    id: string | number;
    onChange?: ((event: React.SyntheticEvent, isExpanded: boolean) => void) | null;
};

const ShippingMethodExtraData = (props: ShippingMethodExtraDataProps) => {
    const languageContext = useContext(LanguageContext);

    const shippingMethodsExtraData = [
        {
            id: appConst.ASAFTA,
            translationKey: appConst.EXTRA_DATA_ASAFTA,
        },
        {
            id: appConst.BHSHOPS,
            translationKey: appConst.EXTRA_DATA_SHOPS,
        },
        {
            id: appConst.REGISTERED,
            translationKey: appConst.EXTRA_DATA_REGISTERED,
        },
        {
            id: appConst.BHHOME,
            translationKey: appConst.EXTRA_DATA_BHHOME,
        }
    ];

    const shippingMethodExtraData = shippingMethodsExtraData.find(
        (shippingMethodExtraData) => shippingMethodExtraData.id == props.id
    );
    const extraDataLines = shippingMethodExtraData
        ? languageContext
              .getTranslation(shippingMethodExtraData.translationKey)
              .split("•")
        : [];

    const element = shippingMethodExtraData ?
        <div className="pb-4">
            {extraDataLines.map((line: string, index: number) => (
                <div
                    key={index}
                    className="shipping_method_extra_data text-start font-ploni text-sm leading-none text-secondary-foreground md:text-lg"
                    style={{ borderBottom: "none" }}
                >
                    {line ? `• ${line}` : ""}
                </div>
            ))}
        </div>
        : <></>;

    return (
        <div>
            <Accordion
                icon={null}
                onChange={props.onChange}
                summarySx={{
                    padding: 0,
                    minHeight: "unset",
                }}
                accordionSummary={<div className="shipping_method_extra_data text-start font-ploni text-sm leading-none text-secondary-foreground md:text-lg">
                    <div className="underline decoration-solid pb-4">
                        {languageContext.getTranslation(appConst.EXTRA_DATA)}
                    </div>
                </div>}
                accordionDetails={element}
            />
        </div >
    )
}
export default ShippingMethodExtraData; 
